import { render, staticRenderFns } from "./PopupHeader.vue?vue&type=template&id=1cc739d4&scoped=true&"
import script from "./PopupHeader.vue?vue&type=script&lang=js&"
export * from "./PopupHeader.vue?vue&type=script&lang=js&"
import style0 from "./PopupHeader.vue?vue&type=style&index=0&id=1cc739d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc739d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins\\workspace\\Apps\\WebViewer\\Dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cc739d4', component.options)
    } else {
      api.reload('1cc739d4', component.options)
    }
    module.hot.accept("./PopupHeader.vue?vue&type=template&id=1cc739d4&scoped=true&", function () {
      api.rerender('1cc739d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\viewer\\components\\PopupHeader.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/PopupHeader.vue
// module id = 304
// module chunks = 0